import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@neworg-net/amsuite-core/config';
import { requireHostUrl } from '../shared/required-host-url';
import { httpOptions } from '../constants/http-options.constant';
import { ChannelContact, SubscriptionDto, SubscriptionPatch } from '../models';

/**
 * Client delle sottoscrizioni notifiche dell'utente corrente (servizio Notifier).
 * Bearer (MSAL) e X-Party-Owner-Id (PartyOwnerInterceptor) sono iniettati dagli
 * interceptor per ogni URL sotto baseUrlNotifier: qui nessun header manuale.
 */
@Injectable({ providedIn: 'root' })
export class NotifierSubscriptionsService {
  private _http = inject(HttpClient);
  private readonly config = inject(ConfigService);
  private _baseUrl = requireHostUrl(this.config, 'notifier') + '/notifier/v1/subscriptions';

  getSubscriptions(): Observable<SubscriptionDto[]> {
    return this._http.get<SubscriptionDto[]>(this._baseUrl, httpOptions);
  }

  getAvailableContacts(channel: number): Observable<ChannelContact[]> {
    return this._http.get<ChannelContact[]>(`${this._baseUrl}/contacts?channel=${channel}`, httpOptions);
  }

  updateSubscription(id: number, patch: SubscriptionPatch): Observable<SubscriptionDto> {
    return this._http.patch<SubscriptionDto>(`${this._baseUrl}/${id}`, patch, httpOptions);
  }
}
